// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"795189d5","404":"acb25048","498":"44accced","787":"0bcc1885"}[chunkId] + ".chunk.js";
};